import { Injectable } from '@angular/core';
import {
  Logger,
  LOG_SOURCE,
  AbstractLogger,
  getDaVinciAgentConfig,
  LOGGER_TYPE,
  ConsoleLogger,
  FileLogger,
  PremiseLogger,
  IAppConfiguration
} from '@amc-technology/davinci-api';
import { IClientConfiguration } from '../models/IClientConfiguration';
import {
  ILoggerConfiguration,
  defaultLoggerConfiguration
} from '@amc-technology/davinci-api/dist/models/LoggerConfiguration';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  private _logger?: Logger;
  private _fileName = 'logger.service.ts';

  constructor(private configService: ConfigurationService) {}

  get logger() {
    if (!this._logger) {
      throw new Error('Logger not initialized!');
    }

    return this._logger;
  }

  async initialize() {
    try {
      // Get raw config. Framework does not perform data validation intentionally
      const rawConfig = await getDaVinciAgentConfig();

      // Perform data validation, revert to defaults if configs are invalid
      // or undefined

      let logLevel = parseInt(
        rawConfig?.variables?.['Log Level']?.toString(),
        10
      );

      logLevel = isNaN(logLevel)
        ? defaultLoggerConfiguration['Log Level']
        : logLevel;

      let maxLength = parseInt(
        (rawConfig?.['Console Logger'] as IAppConfiguration)?.variables?.['Max Length']?.toString(),
        10
      );

      maxLength = isNaN(maxLength)
        ? defaultLoggerConfiguration['Console Logger']['Max Length']
        : maxLength;

      const loggerConfig: ILoggerConfiguration = {
        'Log Level': logLevel,
        'Logger Type':
          rawConfig?.variables?.['Logger Type']?.toString() ||
          defaultLoggerConfiguration['Logger Type'],
        'Premise Logger URL':
          rawConfig?.variables?.['Premise Logger URL']?.toString() ||
          defaultLoggerConfiguration['Premise Logger URL'],
        'Console Logger': {
          'Max Length': maxLength
        }
      };

      this._logger = new Logger(
        LOG_SOURCE.GenesysEngageWWE,
        false,
        this.configService.serverConfig.loggerApiUrl
      );

      this.logger.setConfiguration(loggerConfig);
    } catch (err) {
      this._logger = new Logger(
        LOG_SOURCE.GenesysEngageWWE,
        false,
        this.configService.serverConfig.loggerApiUrl
      );

      this.logger.logCritical(
        'loggerService.initialize(): Error creating logger!'
      );
    }
  }

  /**
  * Add logs for the start or end of a function
  * @param isStart: defines whether it is START or END. Default value is false.
  * @param fnName fnName: function's name
  * @param fileName: the file name the funcion is in
  */
  logFnPerimeter(fileName: string, fnName: string, isStart = false) {
    const _fnName = 'logFunctionPerimeter';
    const _pType = isStart ? 'START' : 'END'; // This defines start or end
    try {
      // this.logger.logDebug(`${fileName} - ${fnName} - ${_pType}`);
      this._logger?.logDebug(`${fileName} - ${fnName} - ${_pType}`);
    } catch (error) {
      this._logger?.logError(`There was an error while attempting to log the function perimeter: ${error}`);
    }
  }
}
